/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_c_master_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MASTER's six letters (M, A, S, T, E, R) rearrange into STREAM, the most recognizable anagram, along with TAMERS and MATERS, both valid but less common. All three use the exact same letters as MASTER, just in a different order.`)
};

const es_wu_c_master_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las seis letras de MASTER (M, A, S, T, E, R) se reordenan en STREAM, el anagrama más reconocible, junto con TAMERS y MATERS, ambas válidas pero menos comunes. Las tres usan exactamente las mismas letras que MASTER, solo que en otro orden.`)
};

const de_wu_c_master_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MASTERs sechs Buchstaben (M, A, S, T, E, R) lassen sich zu STREAM umstellen, dem am leichtesten erkennbaren Anagramm, sowie zu TAMERS und MATERS, beide gültig, aber weniger gebräuchlich. Alle drei nutzen exakt dieselben Buchstaben wie MASTER, nur in anderer Reihenfolge.`)
};

const nl_wu_c_master_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MASTER's zes letters (M, A, S, T, E, R) vormen samen STREAM, het meest herkenbare anagram, naast TAMERS en MATERS, beide geldig maar minder gangbaar. Alle drie gebruiken exact dezelfde letters als MASTER, alleen in een andere volgorde.`)
};

const fr_wu_c_master_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les six lettres de MASTER (M, A, S, T, E, R) se réarrangent en STREAM, l'anagramme la plus reconnaissable, ainsi qu'en TAMERS et MATERS, toutes deux valides mais moins courantes. Les trois utilisent exactement les mêmes lettres que MASTER, simplement dans un ordre différent.`)
};

const it_wu_c_master_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le sei lettere di MASTER (M, A, S, T, E, R) si ricombinano in STREAM, l'anagramma più riconoscibile, insieme a TAMERS e MATERS, entrambe valide ma meno comuni. Tutte e tre usano esattamente le stesse lettere di MASTER, solo in un ordine diverso.`)
};

const pt_br2_wu_c_master_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As seis letras de MASTER (M, A, S, T, E, R) se rearranjam em STREAM, o anagrama mais reconhecível, além de TAMERS e MATERS, ambas válidas mas menos comuns. As três usam exatamente as mesmas letras de MASTER, apenas em ordem diferente.`)
};

const pt_wu_c_master_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As seis letras de MASTER (M, A, S, T, E, R) reorganizam-se em STREAM, o anagrama mais reconhecível, além de TAMERS e MATERS, ambas válidas mas menos comuns. As três usam exatamente as mesmas letras que MASTER, apenas por ordem diferente.`)
};

const ja_wu_c_master_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MASTERの6文字（M, A, S, T, E, R）を並べ替えると、最も認識されやすいアナグラムであるSTREAMに加え、有効ではあるもののあまり一般的ではないTAMERSとMATERSができます。この3つはいずれもMASTERとまったく同じ文字を、順序を変えて使っています。`)
};

const zh_wu_c_master_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`MASTER 的六个字母（M、A、S、T、E、R）可以重新排列成 STREAM——这是最容易辨认的易位构词，此外还有 TAMERS 和 MATERS，两者都有效但较不常见。这三个单词都使用了与 MASTER 完全相同的字母，只是顺序不同。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_c_master_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_c_master_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_c_master_faq1_a", locale)
	if (locale === "en") return en_wu_c_master_faq1_a(inputs)
	if (locale === "es") return es_wu_c_master_faq1_a(inputs)
	if (locale === "de") return de_wu_c_master_faq1_a(inputs)
	if (locale === "nl") return nl_wu_c_master_faq1_a(inputs)
	if (locale === "fr") return fr_wu_c_master_faq1_a(inputs)
	if (locale === "it") return it_wu_c_master_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_wu_c_master_faq1_a(inputs)
	if (locale === "pt") return pt_wu_c_master_faq1_a(inputs)
	if (locale === "ja") return ja_wu_c_master_faq1_a(inputs)
	return zh_wu_c_master_faq1_a(inputs)
};